import ExamDetailPage from "./ExamDetailPage";

// Kısa / SEO dostu sınav URL'leri (/tyt, /ayt, /kpss, /lgs ...) için sarmalayıcı.
// Aynı zengin içeriği, belirli bir sınav slug'ı ile sabitler.
export default function ShortExamPage({ slug }: { slug: string }) {
  return <ExamDetailPage slugOverride={slug} />;
}